export default __webpack_public_path__ + "9a6edb721434140f2569a3c151fd05e4.png";